import { render, staticRenderFns } from "./ActivityVrEditor.vue?vue&type=template&id=34a9878a&scoped=true"
import script from "./ActivityVrEditor.vue?vue&type=script&lang=js"
export * from "./ActivityVrEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9878a",
  null
  
)

export default component.exports